module.exports = __webpack_public_path__ + "static/media/App_ms.308c15ae.png";